<!-- <app-test-menu (projPassToParent)='projPassFromMenu($event)'></app-test-menu> -->
<app-parsing-building-from-json *ngIf="this.proj" [proj]="this.proj"></app-parsing-building-from-json>
<app-go-to-project *ngIf="!removeCloseButton && !compositeDesign"></app-go-to-project>
<!-- <input type="text" [value]="routeNavigate" class="hide-url" #userinput>
<button (click)="copyInputMessage(userinput)" class="share-url" *ngIf="this.showComponents"></button>

<span class="show-coppy-note" [class.active]="showCopyNote">{{ 'COPIED' | translate }}</span>
<a class="fa-whatsapp share-whatsapp" *ngIf="this.showComponents">
  <div class="whatsapp-menu-trigger" (click)="showPhoneF()">
    <ul class="whatsapp-menu" *ngIf="showPhone">
      <li (click)="showPhoneNumber = !showPhoneNumber"><a href="javascript:;">{{ 'PHONE-NUMBER' | translate }}</a></li>
      <li><a href="https://api.whatsapp.com/send?&text={{ routeNavigate + '?m=all' }}" target="_blank">{{ 'USER-LIST' |
          translate }}</a></li>
    </ul>
  </div>

  <div class="add-phone-numbrer" *ngIf="showPhoneNumber">
    <mat-form-field appearance="fill">
      <select class="area-code" matNativeControl required>
        <option (click)="this.areaCode = code" type="number" *ngFor="let code of areaCodes" value="{{ code }}">{{ code
          }}
        </option>
      </select>
    </mat-form-field>

    <input [(ngModel)]='phoneNumber' type="number" pattern="/[^\d+]/" placeholder="050 1111111"
      name="phone-number">
    <a class="btn"
      href="https://api.whatsapp.com/send?text={{ routeNavigate + '?m=all' + '&phone='+ areaCode + phoneNumber }}"
      target="_blank">שלח</a>
  </div>
</a>
<a *ngIf="showCloser" class="close-section close-fixed" href="javascript:;" (click)='goToBuilding()'></a> -->


<div *ngIf="this.showComponents" class="building-unika">
    <div *ngIf="this.building" class="square-design build-content2"
         [class.show-prototype-name]="this.building.showProto">
        <!-- <app-flat-properties-test *ngIf="compositeDesign"></app-flat-properties-test> -->
        <app-n-page-with-link *ngIf="this.building.id" [parentId]='this.building.id' [showPageWithLinkMenu]='false'
                              (showCloser)="showCloserF($event)"></app-n-page-with-link>
        <!-- {{ this.building.projId }} { this.building.floors }} -->
        <!-- <div *ngIf='building.withBuilding' class="build-content-holder"> -->
        <div class="build-content-holder">
            <div class="row build-hoder demo" [attr.data-numroom]="howMuchRoomsHighlight" data-demo-step="1">

                <!-- <span *ngIf="unika" class="question" (click)=showCurrentExplanation($event)>?</span>
                <div class="explanation left">
                  <div class="all-wrapper"></div>
                  <span class="close-explanation" (click)="closeExplanation()"></span>
                  <span class="step-number">1</span>
                  <span class="text">
                    סכמה של כל הדירות בבניין לפי קומות. <br />
                    בלחיצה על הדירה יפתח דף עם המידע של אותה הדירה.
                  </span>
                  <div class="explanation-nav">
                    <button class="btn prev-step" (click)="prevnextF($event, 'next')">הבאה</button>
                    <button class="btn next-step" (click)="prevnextF($event, 'prev')">קודם</button>
                  </div>
                </div> -->

                <h3 class="title">{{ building.name }}</h3>
                <div class="choise-num-of-rooms demo" data-demo-step="2">

                    <!-- <span class="question" (click)=showCurrentExplanation($event)>?</span> -->
                    <div class="explanation left">
                        <div class="all-wrapper"></div>
                        <span class="close-explanation" (click)="closeExplanation()"></span>
                        <span class="step-number">2</span>
                        <span class="text">
              לחיצה על מספר החדרים יסומנו דירות רלוונטיות לאותה כמות החדרים המבוקשת.
            </span>
                        <div class="explanation-nav">
                            <button class="btn prev-step" (click)="prevnextF($event, 'next')">הבאה</button>
                            <button class="btn next-step" (click)="prevnextF($event, 'prev')">קודם</button>
                        </div>
                    </div>
                    <!-- <app-how-much-rooms [building]="building" (currentRoomAmount)="currentRoomAmountF($event)"></app-how-much-rooms> -->
                    <!-- <span>{{ 'SELECT-QUANTITY-ROOMS' | translate }}</span>
                    <ul class="num-of-rooms" *ngIf="building.showRoomsSwitcher != undefined">
                      <li (click)="howMuchRooms(+numRooms, $event)"
                        *ngFor="let numRooms of building.showRoomsSwitcher | sortNumberArray: '': true">
                        {{ numRooms }}
                      </li>
                    </ul> -->
                </div>
                <div class="building building-top col {{ flatStatusClass }}" [class.remove]="activeDataForUser"
                     [class.hide]="showPlaceHolderBuildingImage">
                    <div *ngIf="buildType !== 'office'" class="titles-with-icons"
                         [class.hiden-room-number]="!hideRoomNumberProperty">
                        <span class="floor-title"><span>{{ 'FLOOR' | translate }}</span></span>
                        <span class="flat-number-title"><span>{{ 'UNIT-NAME' | translate }}</span></span>
                        <span *ngIf="hideRoomNumberProperty && buildType !== 'office'"
                              class="numberOfRooms-title"><span>{{ 'ROOM-QUANTITY' | translate }}</span></span>
                        <span *ngIf="buildType === 'office'"
                              class="balconies-size-title"><span>{{ 'BALCONY-SQUARE-METER' | translate }}</span></span>
                        <span class="flat-size-title"><span>{{ 'UNIT-SQUARE-METER' | translate }}</span></span>
                        <span class="flat-status-title"><span>{{ 'STATUS' | translate }}</span></span>
                    </div>
                    <div *ngIf="buildType === 'office'" class="titles-with-icons"
                         [class.hiden-room-number]="!hideRoomNumberProperty">
                        <!-- <span class="floor-title"><span>{{ 'FLOOR' | translate }}</span></span> -->
                        <span class="flat-number-title"><span>{{ 'UNIT-NAME' | translate }}</span></span>
                        <!-- <span *ngIf="hideRoomNumberProperty && buildType !== 'office'" class="numberOfRooms-title"><span>{{ 'ROOM-QUANTITY' | translate }}</span></span> -->
                        <span class="flat-size-title"><span>{{ 'UNIT-SQUARE-METER' | translate }}</span></span>
                        <span class="flat-size-title"><span>{{ 'BALCONY-SQUARE-METER' | translate }}</span></span>
                        <span class="flat-size-title"><span>{{ 'SHELTER-SQUARE-METER' | translate }}</span></span>
                        <span class="flat-status-title"><span>{{ 'STATUS' | translate }}</span></span>
                    </div>
                    <app-view-floor-test *ngIf="building.uid" [buildId]=building.id
                                         [buildUid]=building.uid></app-view-floor-test>
                    <div class="demo" data-demo-step="3">
                        <!-- <span class="question" (click)=showCurrentExplanation($event)>?</span> -->
                        <div class="explanation">
                            <div class="all-wrapper"></div>
                            <span class="close-explanation" (click)="closeExplanation()"></span>
                            <span class="step-number">3</span>
                            <span class="text">
                בבחירת אחד מאפשרויות סטאטוס דירה יודגשו דירות עם אותו הסטאטוס.
                <ul>
                  <li>נמכר - דירות שנמכרו</li>
                  <li>בהרשמה - דירות שכרגע בתהליך מכירה, אבל טרם נמכרו</li>
                  <li style="list-style: decimal outside none;">פנוי - דירות פנויות למכירה</li>
                </ul>
              </span>
                            <div class="explanation-nav">
                                <button class="btn prev-step" (click)="prevnextF($event, 'next')">הבאה</button>
                                <button class="btn next-step" (click)="prevnextF($event, 'prev')">קודם</button>
                            </div>
                        </div>
                        <app-flat-sale-status *ngIf="!compositeDesign"
                                              (flatStatusClass)="flatStatusClassF($event)"></app-flat-sale-status>
                        <!-- <div class="flat-status-menu">
                          <div (click)="showStatus('sold')" [class.active]="statusSold">{{ 'SOLD' | translate }}</div>
                          <div (click)="showStatus('waiting')" [class.active]="statusWating">{{ 'IN-REGISTRATION' | translate }}
                          </div>
                          <div (click)="showStatus('free')" [class.active]="statusFree">{{ 'FREE' | translate }}</div>
                          <div (click)="showStatus('remove')" [class.active]="!statusFree && !statusWating && !statusSold">{{ 'ALL'
                            | translate }}
                          </div>
                        </div> -->
                    </div>
                </div>
            </div>

            <!-- <button *ngIf="!item.noMedia" class="show-3dBuillding btn accent big-button" (click)='show3dBuilding()'>הצג
                      הדמייה</button>

                  <div class="building building-top col {{ flatStatusClass }}" [class.remove]="activeDataForUser"
                      [class.hide]="showPlaceHolderBuildingImage">
                      <div class="building-right"></div>
                      <app-view-floor [buildId]=item.id [buildUid]=item.uid></app-view-floor>
                      <div class="building-left"></div>
                      <div class="flat-status-menu">
                          <div (click)="showStatus('sold')" [class.active]="statusSold">נמכר</div>
                          <div (click)="showStatus('waiting')" [class.active]="statusWating">בהרשמה</div>
                          <div (click)="showStatus('free')" [class.active]="statusFree">פנוי</div>
                          <div (click)="showStatus('remove')"
                              [class.active]="!statusFree && !statusWating && !statusSold">הכל</div>
                      </div>
                  </div>
                  <div class="place-holder-building-img" [class.show]="showPlaceHolderBuildingImage">
                      <img src="../../assets/img/imagePlaceHolder.jpg" style="max-height: 650px;" alt="">
                  </div>
                  <div class="col data-for-user" [class.active]="activeDataForUser">
                      <a *ngIf=!removeAllMenu class="close-section close-fixed close-display" (click)="closeDataUser()"
                          href="javascript:;"></a>
                      <app-view-flat-properties [projUid]=projUid [projId]=projId [build]=item.floors
                          [buildName]=item.name>
                      </app-view-flat-properties>
                      <app-data-for-user *ngIf="showActiveDataForUser" [projUid]=projUid [items]=items
                          [flatProperties]=activeDataForUser class="row">
                      </app-data-for-user>
                  </div>

              </div>
              -->
            <!-- <div class="media-holder" @slideTransform1 *ngIf="p3dBuilding && !building.noMedia"> -->
            <div class="media-holder" *ngIf="p3dBuilding && !building.noMedia && !compositeDesign">
                <a *ngIf=!removeAllMenu class="close-section" href="javascript:;" (click)='close3dBuilding()'></a>
                <app-gallery [galleryId]="'1'" [section]="building.id+'3dOrImages'" [autoPlay]="true"
                             [showThumbs]="true"
                             [resizeDrag]="false" class="simple-gall build-simple-gal"></app-gallery>
            </div>
            <div class="background-image-building-holder">
                {{ building.id }}
                <app-gallery [galleryId]="'backgroundImageBuilding'" [section]="building.id+'backgroundImageBuilding'"
                             [autoPlay]="true" [showThumbs]="true" [resizeDrag]="false"
                             class="simple-gall build-simple-gal background-image-building"></app-gallery>
            </div>
        </div>
        <div *ngIf='building.floors'>
            <div *ngIf='building.withSimulation || building.floors.length == 0'>
                <h3 class="title">{{ building.name }}</h3>
                <app-gallery [galleryId]="'1'" [section]="building.id+'images'" [autoPlay]="true" [showThumbs]="true"
                             [resizeDrag]="false" class="simple-gall build-simple-gal"></app-gallery>
            </div>
        </div>
    </div>
</div>
